import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import _ from "lodash";

export function CustomTextfield({ id, values, errors, onChange, gridValues }) {
  return (
    <Grid item xs={gridValues.xs} sm={gridValues.sm}>
      <TextField
        name={id}
        required
        fullWidth
        multiline
        id={id}
        label={_.startCase(id)}
        value={values[id]}
        onChange={(e) => onChange(e)}
        error={errors && errors[id] && true}
        helperText={errors && errors[id] !== "" ? errors[id] : ""}
      />
    </Grid>
  );
}
